import React, { useState } from 'react';
import { useShop } from '../../context/ShopContext';
import { 
  PhoneCall, 
  Calendar, 
  User, 
  MessageCircle, 
  CheckCircle, 
  Plus, 
  Search, 
  X, 
  Sparkles,
  MapPin,
  Mail,
  Edit2
} from 'lucide-react';

export default function AdminInquiries() {
  const { consultations, updateInquiryStatus, addInquiry, addToast } = useShop();

  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const [newLeadForm, setNewLeadForm] = useState({
    name: '',
    phone: '',
    email: '',
    city: 'Jaipur',
    interest: '',
    notes: ''
  });

  const filteredInquiries = consultations.filter((item) => {
    const matchesStatus = filterStatus === 'all' || item.status === filterStatus;
    const matchesSearch = 
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.phone?.includes(searchTerm) ||
      item.interest?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  const handleCall = (phone) => {
    window.open(`tel:${phone}`);
  };

  const handleWhatsApp = (item) => {
    const text = encodeURIComponent(`Namaste ${item.name}, this is regarding your bespoke consultation request with M.L. Jewellers & Kitchenware (${item.interest}). Our senior bridal and luxury jewellery consultant is delighted to assist you.`);
    window.open(`https://api.whatsapp.com/send?phone=91${item.phone}&text=${text}`, '_blank');
  };

  const handleCreateLead = (e) => {
    e.preventDefault();
    if (!newLeadForm.name.trim() || !newLeadForm.phone.trim()) {
      addToast('Please enter patron name and mobile number', 'error');
      return;
    }

    addInquiry({
      name: newLeadForm.name.trim(),
      phone: newLeadForm.phone.trim(),
      email: newLeadForm.email.trim(),
      city: newLeadForm.city.trim(),
      interest: newLeadForm.interest.trim() || 'General Luxury Heritage Consultation',
      notes: newLeadForm.notes.trim()
    });

    setIsAddModalOpen(false);
    setNewLeadForm({
      name: '',
      phone: '',
      email: '',
      city: 'Jaipur',
      interest: '',
      notes: ''
    });
  };

  return (
    <div>
      {/* Header */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        marginBottom: '1.5rem'
      }}>
        <div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: 'var(--gold-400)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.3rem' }}>
            <Sparkles size={13} /> Concierge Pipeline
          </div>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#fff' }}>
            VIP Consultations & <span className="text-gold-gradient">Client Leads</span>
          </h2>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            Appointments booked for high-value bridal trousseau viewings, solitaires, and luxury kitchenware sets.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '0.8rem', alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            background: '#13131e',
            border: '1px solid var(--border-subtle)',
            borderRadius: 'var(--radius-sm)',
            padding: '0.45rem 0.8rem',
            width: '230px'
          }}>
            <Search size={15} color="var(--gold-400)" style={{ marginRight: '0.5rem' }} />
            <input
              type="text"
              placeholder="Search patron or inquiry..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                color: '#fff',
                fontSize: '0.84rem',
                width: '100%'
              }}
            />
          </div>

          <button
            className="btn btn-gold btn-sm"
            onClick={() => setIsAddModalOpen(true)}
            style={{ display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.82rem' }}
          >
            <Plus size={16} />
            <span>Register New Lead</span>
          </button>
        </div>
      </div>

      {/* Filter Tabs */}
      <div style={{
        display: 'flex',
        gap: '0.6rem',
        overflowX: 'auto',
        paddingBottom: '0.8rem',
        marginBottom: '1.5rem'
      }}>
        {[
          { id: 'all', label: 'All Inquiries' },
          { id: 'New Lead', label: 'New Leads' },
          { id: 'Contacted', label: 'Contacted' },
          { id: 'Scheduled', label: 'Scheduled' },
          { id: 'Converted', label: 'Converted' },
          { id: 'Closed', label: 'Closed' }
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setFilterStatus(tab.id)}
            style={{
              background: filterStatus === tab.id ? 'var(--gold-gradient)' : '#13131e',
              color: filterStatus === tab.id ? '#0a0a0f' : 'var(--text-secondary)',
              border: filterStatus === tab.id ? '1px solid var(--gold-300)' : '1px solid var(--border-subtle)',
              padding: '0.4rem 0.9rem',
              borderRadius: 'var(--radius-full)',
              fontSize: '0.78rem',
              fontWeight: 700,
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Leads Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '1.25rem' }}>
        {filteredInquiries.length === 0 ? (
          <div style={{
            gridColumn: '1 / -1',
            textAlign: 'center',
            padding: '4rem 1rem',
            background: '#13131e',
            borderRadius: 'var(--radius-md)',
            color: 'var(--text-muted)'
          }}>
            <User size={40} color="var(--gold-400)" style={{ margin: '0 auto 0.8rem', opacity: 0.6 }} />
            <h4 style={{ color: '#fff', fontSize: '1.1rem' }}>No Consultation Leads Found</h4>
            <p style={{ fontSize: '0.85rem' }}>Try clearing filters or search criteria.</p>
          </div>
        ) : (
          filteredInquiries.map((item) => (
            <div
              key={item.id}
              style={{
                background: '#13131e',
                border: '1px solid var(--border-subtle)',
                borderRadius: 'var(--radius-md)',
                padding: '1.5rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.9rem'
              }}
            >
              {/* Top row */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="badge badge-gold" style={{ fontSize: '0.7rem' }}>
                  {item.id} • {item.date}
                </span>

                {/* Status Selector */}
                <select
                  value={item.status}
                  onChange={(e) => updateInquiryStatus(item.id, e.target.value)}
                  style={{
                    background: '#0d0d16',
                    border: '1px solid var(--border-gold)',
                    color: item.status === 'Converted' ? '#34d399' : item.status === 'Scheduled' ? '#60a5fa' : 'var(--gold-400)',
                    fontWeight: 700,
                    padding: '0.25rem 0.6rem',
                    borderRadius: 'var(--radius-sm)',
                    fontSize: '0.74rem',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <option value="New Lead">New Lead</option>
                  <option value="Contacted">Contacted</option>
                  <option value="Scheduled">Scheduled</option>
                  <option value="Converted">Converted</option>
                  <option value="Closed">Closed</option>
                </select>
              </div>

              {/* Client Info */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <div style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, rgba(20, 20, 30, 0.8) 100%)',
                  border: '1px solid var(--border-gold)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <User size={18} color="var(--gold-400)" />
                </div>
                <div>
                  <div style={{ fontWeight: 800, color: '#fff', fontSize: '0.98rem' }}>{item.name}</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.78rem' }}>
                    +91 {item.phone} {item.city ? `• ${item.city}` : ''}
                  </div>
                </div>
              </div>

              {/* Requirement Box */}
              <div style={{
                background: '#0a0a10',
                border: '1px solid rgba(212, 175, 55, 0.15)',
                borderRadius: 'var(--radius-sm)',
                padding: '0.85rem',
                fontSize: '0.82rem',
                color: 'var(--text-secondary)'
              }}>
                <div style={{ color: 'var(--gold-400)', fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase', marginBottom: '0.2rem' }}>
                  Patron Requirement / Interest:
                </div>
                {item.interest}
              </div>

              {/* Notes */}
              {item.notes && (
                <div style={{
                  fontSize: '0.76rem',
                  color: 'var(--text-muted)',
                  fontStyle: 'italic',
                  background: 'rgba(255, 255, 255, 0.02)',
                  padding: '0.4rem 0.6rem',
                  borderRadius: '4px'
                }}>
                  <strong>Concierge Note:</strong> {item.notes}
                </div>
              )}

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: '0.6rem', marginTop: 'auto', paddingTop: '0.5rem' }}>
                <button
                  className="btn btn-gold btn-sm"
                  onClick={() => handleCall(item.phone)}
                  style={{ flex: 1, fontSize: '0.78rem' }}
                >
                  <PhoneCall size={14} /> Call Client
                </button>
                <button
                  className="btn btn-glass btn-sm"
                  onClick={() => handleWhatsApp(item)}
                  style={{ fontSize: '0.78rem', color: '#25D366' }}
                >
                  <MessageCircle size={15} /> WhatsApp
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Register New Lead Modal */}
      {isAddModalOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1.5rem'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '480px',
            backgroundColor: '#13131e',
            border: '1px solid var(--border-gold)',
            borderRadius: 'var(--radius-md)',
            padding: '2rem',
            position: 'relative'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#fff' }}>
                  Register VIP Consultation Lead
                </h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                  Record a showroom walk-in patron or phone enquiry.
                </p>
              </div>
              <button
                onClick={() => setIsAddModalOpen(false)}
                style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer' }}
              >
                <X size={20} />
              </button>
            </div>

            <form onSubmit={handleCreateLead} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem' }}>
                  Patron Name *
                </label>
                <input
                  type="text"
                  required
                  placeholder="e.g. Radhika Mandhana"
                  value={newLeadForm.name}
                  onChange={(e) => setNewLeadForm({ ...newLeadForm, name: e.target.value })}
                  className="input-luxury"
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem' }}>
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    required
                    placeholder="98290 11223"
                    value={newLeadForm.phone}
                    onChange={(e) => setNewLeadForm({ ...newLeadForm, phone: e.target.value })}
                    className="input-luxury"
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem' }}>
                    City / Location
                  </label>
                  <input
                    type="text"
                    placeholder="Jaipur / Delhi"
                    value={newLeadForm.city}
                    onChange={(e) => setNewLeadForm({ ...newLeadForm, city: e.target.value })}
                    className="input-luxury"
                  />
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem' }}>
                  Specific Requirement / Interest *
                </label>
                <input
                  type="text"
                  required
                  placeholder="e.g. Bridal Kundan Haar Set with budget ₹8-10 Lakhs"
                  value={newLeadForm.interest}
                  onChange={(e) => setNewLeadForm({ ...newLeadForm, interest: e.target.value })}
                  className="input-luxury"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: 'var(--gold-400)', marginBottom: '0.3rem' }}>
                  Follow-up Notes / Preferred Timing
                </label>
                <textarea
                  rows={2}
                  placeholder="Client visiting showroom on Sunday afternoon with family."
                  value={newLeadForm.notes}
                  onChange={(e) => setNewLeadForm({ ...newLeadForm, notes: e.target.value })}
                  className="input-luxury"
                  style={{ resize: 'vertical' }}
                />
              </div>

              <div style={{ display: 'flex', gap: '0.8rem', marginTop: '1rem' }}>
                <button
                  type="button"
                  onClick={() => setIsAddModalOpen(false)}
                  className="btn btn-glass"
                  style={{ flex: 1 }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-gold"
                  style={{ flex: 1 }}
                >
                  Save VIP Lead
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
